import React, { useEffect } from 'react';
import MalaysiaLaunch from '../images/Malaysia-Launch.jpeg'
import UKLaunch from '../images/UK-Launch.jpeg'
import RussiaEvent from '../images/RussiaEvent.png'
import AILaunch from '../images/Launch.jpeg'

const LatestNews = () => {
  useEffect(() => {
    // This effect manages the stylesheet for hovers and responsiveness
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      /* --- Hover Effects --- */
      .news-card:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
      }
      
      .news-card:hover img {
        transform: scale(1.05);
      }
      
      .news-card .read-more-button:hover {
        background-color: #f0f0f0;
        border-color: #ccc;
        color: #333;
      }
      
      /* --- Responsive Design --- */
      @media (max-width: 768px) {
        .main-container {
          padding: 40px 15px !important;
        }
        .main-title {
          font-size: 38px !important;
        }
        .news-card {
          width: 85% !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const newsItems = [
    { id: 1, category: 'Launch', categoryColor: '#f103e9ff', date: 'July 26, 2025', title: 'Global AI Society Launches AI Training Kit in Malaysia and Singapore', description: 'Four pioneering figures—including Dr. Paula Noble Fellingham, Mr. Way Sun, Elle Quan, and Dr. Hari Krishna Maram—launched the AI learning initiative', image: MalaysiaLaunch },
    { id: 2, category: 'Programs', categoryColor: '#42A5F5', date: 'July 17, 2025', title: 'New AI Certification Program Launches Globally', description: 'We are proud to introduce our comprehensive AI certification program, designed to bridge the gap between academic learning and industry demands.', image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80' },
    { id: 3, category: 'Launch', categoryColor: '#5C6BC0', date: 'July 9, 2025', title: 'Global AI Society Launches AI Training Kit at University of Westminster, UK', description: 'This new product provides practical AI learning resources designed to equip students and educators with the skills needed for today’s digital world.', image: UKLaunch },
    { id: 4, category: 'Milestones', categoryColor: '#66BB6A', date: 'June 5, 2024', title: '130,000 Students Milestone Reached', description: 'We celebrate reaching our milestone of training over 130,000 students worldwide through our innovative AI education programs.', image: 'https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80' },
    { id: 5, category: 'Event', categoryColor: '#4A90E2', date: 'May 12, 2025', title: 'AI Education Accessibility Event in Russia', description: 'AI event in Russia brought together educators and experts to discuss and promote accessibility in AI education.', image: RussiaEvent },
    { id: 6, category: 'inauguration', categoryColor: '#26A69A', date: 'May 3, 2025', title: 'AICTE Chairman Inaugurates AI Trainer Kit', description: 'The AI Trainer Kit powered by Intel was officially inaugurated by AICTE Chairman Prof. Dr. T.G. Sitharam.', image: AILaunch }
  ];

  return (
    <div style={styles.container} className="main-container">
      <div style={styles.content}>
        <h1 style={styles.title} className="main-title">Latest Updates</h1>
        
        <div style={styles.grid}>
          {newsItems.map((item) => (
            <div key={item.id} style={styles.card} className="news-card">
              <div style={styles.imageContainer}>
                <img src={item.image} alt={item.title} style={styles.image} />
                <div style={{ ...styles.categoryBadge, backgroundColor: item.categoryColor }}>
                  {item.category}
                </div>
              </div>
              
              <div style={styles.cardContent}>
                <div style={styles.date}>{item.date}</div>
                <h3 style={styles.cardTitle}>{item.title}</h3>
                <p style={styles.cardDescription}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    padding: '60px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#4a4a4a',
    textAlign: 'center',
    marginBottom: '60px',
    letterSpacing: '-0.02em'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '32px',
    alignItems: 'stretch',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    display: 'flex',
    flexDirection: 'column'
  },
  imageContainer: {
    position: 'relative',
    height: '200px',
    overflow: 'hidden'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease'
  },
  categoryBadge: {
    position: 'absolute',
    top: '16px',
    left: '16px',
    color: 'white',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  cardContent: {
    padding: '24px',
    flex: '1',
    display: 'flex',
    flexDirection: 'column'
  },
  date: {
    fontSize: '14px',
    color: '#888',
    marginBottom: '8px',
    fontWeight: '500'
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 12px 0',
    lineHeight: '1.3'
  },
  cardDescription: {
    fontSize: '15px',
    color: '#666',
    lineHeight: '1.6',
    margin: '0 0 20px 0',
    flex: '1',
  },
  readMoreButton: {
    backgroundColor: 'transparent',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '12px 20px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#555',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    alignSelf: 'flex-start'
  }
};

export default LatestNews;